import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function PropertyLocation({ data }) {
  return (
    <>
      <div className="row p-3">
        <div className="col-12 mb-2">
          <span className="text-color font-weight-bold">
            {' '}
            Property Location{' '}
          </span>
        </div>
        <div className="col-12">
          <table className="transaction-table table table-borderless table-striped table-sm ">
            <tbody>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  District
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.landApplication.attributes.property_district_name'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Barangay
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.landApplication.attributes.property_barangay_name'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Province
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.landApplication.attributes.property_province_name'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Street
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.landApplication.attributes.property_street'
                  ) || '--'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-12 mb-2">
          <span className="text-color font-weight-bold"> Land Owner </span>
        </div>
        <div className="col-12">
          <table className="transaction-table table table-borderless table-striped table-sm ">
            <tbody>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Owner
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.isEmpty(_.get(data, 'included.buildingOwner'))
                    ? _.get(data, 'included.landOwner.attributes.name') ?? '--'
                    : '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  PIN
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.isEmpty(_.get(data, 'included.buildingOwner'))
                    ? _.get(data, 'included.landApplication.attributes.pin') ??
                      '--'
                    : '--'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-12 mb-2">
          <span className="text-color font-weight-bold"> Building Owner </span>
        </div>
        <div className="col-12">
          <table className="transaction-table table table-borderless table-striped table-sm ">
            <tbody>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Owner
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'included.buildingOwner.attributes.full_name') ||
                    '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  PIN
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'included.buildingApplication.attributes.pin') ||
                    '--'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

PropertyLocation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  landOwnerInfo: _.get(api, `${c.GET_SINGLE_LAND_OWNER}.item`) || {},
  buildingOwnerInfo: _.get(api, `${c.GET_SINGLE_BUILDING_OWNER}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PropertyLocation);
